import { createSlice } from "@reduxjs/toolkit";
import { fetchPackingDone } from "./thunk";

interface PackingDoneState {
  PackingDoneList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PackingDoneState = {
  PackingDoneList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const PackingDoneSlice = createSlice({
  name: "PackingDone",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackingDone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackingDone.fulfilled, (state, action) => {
        state.loading = false;
        state.PackingDoneList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPackingDone.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch PackingDone ";
      });
  },
});

export default PackingDoneSlice.reducer;
